<template>
  <div class="parentReport">
    <div class="positionbtns">
      <button
        class="butt"
        style="background-color: #6372ff"
        @click="downloadPdf('print')"
      >
        打印
      </button>
      <button
        class="butt"
        style="background-color: #6372ff"
        @click="downloadImg"
      >
        导出图片
      </button>
      <button
        class="butt"
        style="background-color: #6372ff"
        @click="downloadPdf"
      >
        导出pdf
      </button>
    </div>
    <!-- 从这里开始打印 -->
    <div id="myChart" class="myChart">
      <div id="pdfcontent" ref="reportBox" class="report-box">
        <div class="department-container">
          <div class="header">
            <div class="title">《学习风格测评结果报告》</div>
            <!-- <div class="userInfo">
              <div class="name">姓名：{{ list.userName }}</div>
              <div class="timer">测评时间：{{ list.testTime }}</div>
            </div> -->
          </div>
          <div class="main">
            <div class="test">
              <div class="test_content">
                <div class="l">
                  <div class="left_logo">
                    <img src="./images/yq.png" alt="" />
                  </div>
                  <div class="left_title">测试结果</div>
                </div>
                <div class="x"></div>
                <div class="r"><div class="right_title">Test result</div></div>
              </div>
              <div class="exponent">
                <div class="left">
                  通过在问卷的选择，你得出了四个分数，分别指向冲动型、反省型、理论
                  型、实际型。（分值越高，偏好越强烈）
                </div>
                <div class="right">
                  <img src="./images/rightlogo.png" alt="" />
                </div>
              </div>
              <div class="view">
                <div class="view_left">
                  <TypeRadarChart :picCharts="list.picCharts" />
                </div>
                <div class="view_right">
                  <div class="table">
                    <el-table
                      :row-style="{ height: 30 + 'px' }"
                      :data="list.studyStyles"
                      border
                      stripe
                      :header-cell-style="{
                        background: '#d7e0fa',
                        color: '#333333',
                      }"
                    >
                      <el-table-column prop="type" label="类型" align="center">
                      </el-table-column>
                      <el-table-column prop="score" label="分值" align="center">
                      </el-table-column>
                      <el-table-column
                        prop="description"
                        label="偏好等级"
                        align="center"
                        width="90"
                      >
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
            <div class="test">
              <div class="test_content">
                <div class="l">
                  <div class="left_logo">
                    <img src="./images/yq.png" alt="" />
                  </div>
                  <div class="left_title">你的学习风格特征</div>
                </div>

                <div class="x"></div>
                <div class="r">
                  <div class="right_title">Style characteristics</div>
                </div>
              </div>
              <div class="result">
                <div class="body">
                  <div class="body_center">
                    你追求事物的内在含义并习惯亲身体验；你善于通过听和与人分享思想来学习；你喜欢与人沟通；你善于从多个角度观察问题并形成自己独特的观点
                  </div>
                  <div class="body_center">
                    <span>优点：</span> 富于创造力和想像力
                  </div>
                  <div class="body_center">
                    <span>优点：</span> 富于创造力和想像力
                  </div>
                  <div class="body_center">
                    <span>优点：</span> 富于创造力和想像力
                  </div>
                  <div class="body_center">
                    <span>优点：</span> 富于创造力和想像力
                  </div>
                  <div class="body_center" style="color: #5c81f2">
                    策略偏好：1.预先计划和组织2.适时反思3.自我管理4.尊重自我评价5.团队精神6.集体讨论7.演绎推理
                  </div>
                </div>
              </div>
            </div>
            <div class="test">
              <div class="test_content">
                <div class="l">
                  <div class="left_logo">
                    <img src="./images/yq.png" alt="" />
                  </div>
                  <div class="left_title">学习风格测评结果分析</div>
                </div>
                <div class="x"></div>
                <div class="r">
                  <div class="right_title">Style characteristics</div>
                </div>
              </div>
              <div class="result">
                <div
                  class="body"
                  v-for="(item, index) in list.reportItems"
                  :key="index"
                >
                  <div class="body_top">
                    <div class="body_header">
                      <img src="./images/sj.png" alt="" />
                    </div>
                    <div class="body_title">{{ item.title }}</div>
                  </div>
                  <div class="body_btn">
                    {{ item.description }}
                  </div>
                  <div class="body_btn" style="color: #3964e6">
                    {{ item.traits }}
                  </div>
                </div>
              </div>
            </div>
            <div class="test">
              <div class="test_content">
                <div class="l">
                  <div class="left_logo">
                    <img src="./images/yq.png" alt="" />
                  </div>
                  <div class="left_title">任何学习都分为四个阶段</div>
                </div>
                <div class="xx"></div>
                <div class="r">
                  <div class="right_title">Four stages</div>
                </div>
              </div>
              <div class="result">
                <div class="body">
                  <div class="body_center">
                    <span>1) 冲动型：</span> 任何事情我都将尝试一次。
                  </div>
                  <div class="body_center">
                    <span>2) 务实型：</span> 我喜欢有时间考虑考虑。
                  </div>
                  <div class="body_center">
                    <span>3) 反思型：</span> 这个和那个匹配得如何？
                  </div>
                  <div class="body_center">
                    <span>4) 理论型：</span> 我怎样才能将它应用于实践？
                  </div>
                  <div class="body_centera">
                    每一个风格使你能进行学习周期中的一个不同阶段。在你的所有技能中如果恰到好处地拥有了四种风格，将使你能最好地实施从经验中学习的全部过程。
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="base">
            <div class="leftlogo">
              <div class="base_logo" style="width: 200px">
                <img src="./images/log.png" alt="" />
              </div>
            </div>
            <div class="rightlogo">
              <div class="base_wenzi" style="margin-right: 20px">
                长按识别二维码 你也来测试一下吧～
              </div>
              <div class="base_logo"><img src="./images/ewm.png" alt="" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetStudyStyle } from "@/api/home";
import html2canvas from "html2canvas";
import ExportSavePdf from "@/utils/html2pdf";
import { formatTime } from "@/utils/index.js";
import TypeRadarChart from "@/components/Reports/TypeRadarChart.vue";
export default {
  name: "HSasAnxiety",
  components: {
    TypeRadarChart,
  },
  props: {},
  data() {
    return {
      widths: "300px",
      list: "",
    };
  },

  async mounted() {
    const res = await GetStudyStyle(this.$route.query.CustomScaleId);
    this.list = res.data || res.result;
  },

  methods: {
    // 导出pdf
    downloadPdf(type) {
      ExportSavePdf(
        "pdfcontent",
        `${this.list.userName}的个人报告`,
        formatTime(new Date()),
        type
      );
    },
    /**
     * 下载图片
     */
    downloadImg() {
      console.log("download ....");
      html2canvas(document.querySelector("#myChart")).then((canvas) => {
        const url = canvas.toDataURL();
        this.downloadFile(url, `${this.list.userName}的个人报告`);
      });
    },
    /**
     * @description Base64转Blob
     * @param dataUrl base64地址
     */
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    /**
     * @description 构建a标签，通过a标签下载文件
     * @param url 下载地址
     * @param name 下载的文件名
     */
    downloadFile(url, name = "图片") {
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", name);
      a.setAttribute("target", "_blank");
      const clickEvent = document.createEvent("MouseEvents");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
    },
    /**
     * @description 将得到的base64文件转码下载
     * @param base64 图片base64编码
     * @param name 文件名称
     */
    downloadFileByBase64(base64, name) {
      const myBlob = this.dataURLtoBlob(base64);
      const myUrl = URL.createObjectURL(myBlob);
      this.downloadFile(myUrl, name);
    },
  },
};
</script>

<style lang="less" scoped media="print">
@media print {
  @page {
    margin: 0;
  }
  body {
    margin: 0 1mm 1cm 0; // 此处样式根据实际需要进行设置
  }
}
.parentReport {
  .positionbtns {
    position: fixed;
    width: 100px;
    transform: translateX(467px);
    top: 85px;
    left: 0;
    right: 0;
    margin: auto;
    text-align: right;
    z-index: 1000;
    .butt {
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin-bottom: 15px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      border-radius: 3px;
      border: 0;
      //   box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);
    }
  }
  .report-box {
    width: 794px;
    margin: 0 auto;
    background: #fff;
    .department-container {
      width: 100%;
      font-size: 12px;
      background-image: url("./images/background1.png") !important;
      padding-bottom: 1em;
      box-sizing: border-box;
      background-size: cover;
      .base {
        display: flex;
        justify-content: space-evenly;
        .leftlogo {
          display: flex;
          align-items: center;
          .base_logo {
            width: 35px;
            height: 35px;
            img {
              width: 100%;
            }
          }
          .base_wenzi {
            font-size: 16px;
            color: #fff;
          }
        }
        .rightlogo {
          display: flex;
          align-items: center;
          .base_wenzi {
            font-size: 16px;
            color: #fff;
          }
          .base_logo {
            width: 60px;
            height: 60px;
            img {
              width: 100%;
            }
          }
        }
      }
      .header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        .title {
          font-size: 36px;
          margin: 86px 0 27px 0;
        }
        .userInfo {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          .name {
            margin-right: 50px;
          }
        }
      }

      .main {
        width: auto;
        margin: 25px 30px 30px 30px;
        padding: 40px 40px 100px 40px;
        background: #fff;
        border-radius: 41px 41px 41px 41px;
        box-sizing: border-box;
        .test {
          display: flex;
          flex-direction: column;
          margin-top: 20px;
          position: relative;
          .test_content {
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            justify-content: space-between;
            .l {
              display: flex;
              .left_logo {
                width: 25px;
                height: 15px;
                margin-right: 12px;
                img {
                  width: 100%;
                }
              }
              .left_title {
                font-size: 16px;
                color: #333;
                font-weight: bold;
                padding-right: 10px;
                font-size: 14px;
              }
            }
            .x {
              position: absolute;
              top: 21px;
              left: 160px;
              width: 70%;
              height: 1px;
              background: #e2e2e2;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
            }
            .xx {
              position: absolute;
              top: 21px;
              left: 200px;
              width: 70%;
              height: 1px;
              background: #e2e2e2;
              border-radius: 0px 0px 0px 0px;
              opacity: 1;
            }
            .r {
              .right_title {
                height: 20px;
                font-size: 7px;
                color: #c7c3c3;
                border-bottom: solid 2px #d9d9d9;
                margin-bottom: 20px;
                text-align: center;
              }
            }
          }
          .view {
            width: 100%;
            display: flex;
            height: 300px;
            justify-content: center;
            .view_left {
              width: 100%;
            }
            .view_right {
              width: 100%;
              .table {
                margin-top: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
          .exponent {
            width: 90%;
            height: 46px;
            background: #dae8ff;
            border-radius: 19px 19px 19px 19px;
            opacity: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 47px;
            .left {
              font-size: 14px;
              color: #5c81f2;
              margin-left: 46px;
              span {
                font-weight: bold;
                font-size: 20px;
              }
            }
            .right {
              margin-right: 30px;
              width: 36px;
              height: 36px;
              img {
                height: 100%;
              }
            }
          }
          .result {
            .top {
              .title {
                font-size: 13px;
                color: #666;
                margin-left: 40px;
                .title_t {
                  margin-bottom: 30px; //#FF5925
                }
              }
            }
            .body {
              margin: 20px 30px 0 40px;
              color: #666666;
              .body_center {
                font-size: 14px;
                margin-bottom: 5px;
                span {
                  font-weight: bold;
                }
              }
              .body_centera {
                margin-top: 20px;
                font-size: 14px;
              }
              .body_top {
                display: flex;
                margin-bottom: 10px;
                .body_header {
                  margin-right: 10px;
                }
                .body_title {
                  font-size: 14px;
                  font-weight: bold;
                }
              }
              .body_btn {
                margin-left: 15px;
                font-size: 13px;
                .a {
                  margin-top: 100px;
                }
              }
            }
          }
        }
      }
      //google chrome explore
      -webkit-print-color-adjust: exact;
      //firefox  explore
      -moz-print-color-adjust: exact;
      color-adjust: exact;
    }
  }
}
</style>
